import React from "react";
import { motion } from "framer-motion";
import { SectionHeading } from "./Section";
import { useLang } from "../../i18n";

// deterministic pseudo-random for stable layout
const seeded = (i) => {
  const x = Math.sin(i * 999.13) * 10000;
  return x - Math.floor(x);
};

export const Technology = () => {
  const { t } = useLang();
  const tc = t.tech;

  return (
    <section id="tech" className="relative py-24 md:py-36 overflow-hidden" data-testid="tech-section">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-flame/10 blur-[160px] pointer-events-none" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <SectionHeading overline={tc.overline} title={tc.title} sub={tc.sub} align="center" />

        <div className="relative mt-16 flex flex-wrap items-center justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {tc.items.map((item, i) => {
            const big = i % 4 === 0;
            const r = seeded(i);
            return (
              <motion.span
                key={item}
                data-cursor="hover"
                data-testid={`tech-chip-${i}`}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.03 }}
                whileHover={{ scale: 1.08, color: "#FF6A00", borderColor: "rgba(255,106,0,0.5)" }}
                style={{ animationDelay: `${r * 3}s` }}
                className={`animate-float-slow cursor-default rounded-full border border-white/10 bg-white/[0.03] font-heading font-semibold text-white/70 transition-colors
                  ${big ? "px-7 py-3.5 text-lg md:text-xl" : "px-5 py-2.5 text-sm md:text-base"}`}
              >
                {item}
              </motion.span>
            );
          })}
        </div>
      </div>
    </section>
  );
};
